/**
 * Gespraech mit dem Push-Dienst (F-31) unter `/api/push/*` - dieselbe
 * Herkunft wie die App, also hinter demselben Cloudflare-Access-Login
 * (T-03). Ohne eingerichteten Dienst (z. B. lokal) antwortet `status` mit
 * `verfuegbar: false`, und die App bleibt bei der Glocke.
 */
export interface Geraet {
  id: string;
  name: string;
  erstellt: string;
  zuletzt: string | null;
  /** Gesetzt, wenn der Push-Dienst des Browsers das Abo abgelehnt hat. */
  verloren: string | null;
}

export interface PlanZeile {
  id: string;
  /** UTC, ISO 8601 - aus der lokalen Zeit (Europe/Berlin) umgerechnet. */
  faellig: string;
  titel: string;
  text: string;
  link: string;
}

async function rufe<T>(pfad: string, init?: RequestInit): Promise<T> {
  const r = await fetch(`/api/push/${pfad}`, {
    ...init,
    credentials: 'same-origin',
    headers: { 'content-type': 'application/json', ...init?.headers },
  });
  if (!r.ok) throw new Error(`Push-Dienst: ${r.status}`);
  return (r.status === 204 ? undefined : await r.json()) as T;
}

/** Von welchem Geraet der Plan zuletzt kam. */
export interface PlanStand { quelle: string; zeit: string; anzahl: number }

export async function dienstStatus(): Promise<{ verfuegbar: boolean; publicKey?: string; plan?: PlanStand | null }> {
  try {
    const r = await fetch('/api/push/status', { credentials: 'same-origin' });
    if (!r.ok || !(r.headers.get('content-type') ?? '').includes('json')) return { verfuegbar: false };
    const d = (await r.json()) as { publicKey?: string; plan?: PlanStand | null };
    return d.publicKey ? { verfuegbar: true, publicKey: d.publicKey, plan: d.plan ?? null } : { verfuegbar: false };
  } catch {
    return { verfuegbar: false };
  }
}

export const geraeteLaden = () => rufe<Geraet[]>('geraete');
export const geraetAnmelden = (name: string, abo: PushSubscriptionJSON) =>
  rufe<{ id: string }>('geraete', { method: 'POST', body: JSON.stringify({ name, abo }) });
export const geraetAbmelden = (id: string) => rufe<void>(`geraete/${encodeURIComponent(id)}`, { method: 'DELETE' });
export const planSenden = (quelle: string, eintraege: PlanZeile[]) => rufe<void>('plan', { method: 'PUT', body: JSON.stringify({ quelle, eintraege }) });
export const testSenden = () => rufe<void>('test', { method: 'POST' });
